<template>
  <div>
    <ParentForm
      v-for="(form, index) in forms"
      :key="index"
      :value="form"
      :count="forms.length - 1"
      :disableSubmit="anyErrors"
      :isSending="isSending"
      :forClient="forClient"
      v-on:submitEvent="handleSubmit"
      v-on:inputEvent="handleInput"
      v-on:updateEvent="handleUpdate" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ParentForm from './ParentForm'

export default {
  name: 'ParentFormContainer',
  components: { ParentForm },
  props: ['forClient'],
  data() {
    return {
      forms: [],
      isSending: false
    }
  },
  computed: {
    ...mapGetters(['parents', 'getMyInfo']),
    anyErrors() {
      return this.forms.some(el => el.errors === true)
    }
  },
  created() {
    let parentsArr
    if (!this.forClient) {
      parentsArr = this.getMyInfo.parents
    } else {
      parentsArr = this.parents
    }

    if (parentsArr && parentsArr.length > 0) {
      parentsArr.forEach(p => this.forms.push(this.genFormObj(p)))
    } else {
      this.forms.push(this.genFormObj())
    }
  },
  methods: {
    ...mapActions(['addUserParents', 'doProfileUpdate']),
    handleSubmit: async function() {
      if (this.anyErrors) return
      this.isSending = true
      if (!this.forClient) {
        await this.doProfileUpdate({ parents: this.forms })
        this.$router.push('/account')
      } else {
        await this.addUserParents(this.forms)
        this.$router.push('/user/payment')
      }
    },
    handleUpdate(event, index) {
      if (event === 'add') {
        this.forms.push(this.genFormObj())
      } if (event === 'remove' && index && index < this.forms.length) {
        this.forms.splice(index, 1)
      }
    },
    handleInput(key, value, index) {
      this.forms[index][key] = value
    },
    genFormObj(data) {
      return {
        firstName: (data && data.firstName) ? data.firstName : '',
        lastName: (data && data.lastName) ? data.lastName : '',
        email: (data && data.email) ? data.email : '',
        phone: (data && data.phone) ? data.phone : '',
        errors: false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Forms/ParentFormContainer.vue?6243e2ba